<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div @click="router.push('/')" class="breadcrumbs-txt pointer">主页</div>
      <img class="iconArrow" src="@/assets/iconArrow.png" alt="" />
      <div class="breadcrumbs-txt1 default">关于One A Day®</div>
    </div>
    <div class="main-content flex column jcs">
      <div>
        <div class="bannerBox flex jcc">
          <div style="width: 1371px">
            <img class="ScienceThatMatters" src="@/assets/about/OneADay.png" alt="" />
          </div>
        </div>
        <div class="text-content flex column ai">
          <div class="text1 default">从营养补充到食用感受，One A Day致力于为消费者提供全面优质的产品体验 帮助每一位消费者达到健康生活状态</div>
          <div class="text2 default">提供定制化解决方案</div>
          <div class="text3 default">不同性别，不同年龄，不同人生阶段每个人对于营养补充的需求都大不相同 One A Day是一个多元营养补充剂品牌，我们为消费者提供多样完整的产品组合</div>
          <div class="tab-box flex column ai">
            <!-- tab选项卡 -->
            <div class="tab-item flex jcs">
              <div @click="tabIndex = 0" class="tab-titleBox pointer">
                <div class="tab-title">品牌理念</div>
                <div v-if="tabIndex === 0" class="tab-selectTheBlock"></div>
              </div>
              <div @click="tabIndex = 1" class="tab-titleBox pointer">
                <div class="tab-title">质量保证</div>
                <div v-if="tabIndex === 1" class="tab-selectTheBlock"></div>
              </div>
              <div @click="tabIndex = 2" class="tab-titleBox pointer">
                <div class="tab-title">科学配方</div>
                <div v-if="tabIndex === 2" class="tab-selectTheBlock"></div>
              </div>
            </div>
            <!-- 选项卡内容 -->
            <!-- <div class="tab-contentTitle default">{{ tabList[tabIndex].title }}</div> -->
            <div class="tab-contentText default">{{ tabList[tabIndex].text }}</div>
            <div class="tab-contentImgBox flex jcs">
              <img :style="{ visibility: tabIndex != 0 ? 'visible' : 'hidden' }" @click="changeTab('left')" class="iconLeft pointer" src="@/assets/about/iconLeft.png" alt="" />
              <img :style="{ visibility: tabIndex != 2 ? 'visible' : 'hidden' }" @click="changeTab('right')" class="iconRight pointer" src="@/assets/about/iconRight.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script setup>
import Footer from "../../components/Footer.vue";
import { ref } from "vue";
import router from "@/router";
// tab选中下标
const tabIndex = ref(0);
// tab内容列表
const tabList = ref([
  { title: "品牌理念", text: "80多年来，我们一直引领维生素创新——我们不会停下脚步，我们相信健康是获得更好自我的关键。我们将一直坚持使用专业的原料成分并且持续优化产品配方，以给到消费者科学先进的营养补充。" },
  { title: "质量保证", text: "一直以来，我们在产品质量方面都以最高标准来要求自己。我们的产品都是经过 100 多项严格的质量检查，以确保产品安全与功效。我们致力于以我们能提供的最佳质量为消费者服务。" },
  { title: "科学配方", text: "每一款产品的诞生都离不开我们经验丰富的研发人员和专业科学家团队的共同努力。 我们致力于解决每一位消费者在健康方面的首要需求，研究并开发独家成分配方以满足消费者的差异化需求。" },
]);
// 切换选项卡
const changeTab = (type) => {
  if (type === "left") {
    if (tabIndex.value > 0) {
      tabIndex.value--;
    }
  } else if (type === "right") {
    if (tabIndex.value < tabList.value.length - 1) {
      tabIndex.value++;
    }
  }
};
</script>

<style src="./about.css" scoped></style>
